"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacer = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const Spacing = styled_1.default.div `
	height: ${({ spacing }) => merlin_theme_1.default.layout.spacing[spacing]};
	background-color: unset;
`;
const Spacer = (_a) => {
    var { spacing } = _a, props = __rest(_a, ["spacing"]);
    return react_1.default.createElement(Spacing, Object.assign({ id: "spacer" }, props, { spacing: spacing || 'standard' }));
};
exports.Spacer = Spacer;
//# sourceMappingURL=Spacer.js.map